function CardTechnology(props) {
  return (
    <div className="containerTechnology d-flex-column">
      {props.study === "true" ? (
        <p className="study label">Estudando</p>
      ) : (
        <p className="study label notStudy">Estudando</p>
      )}
      <div className="contentCardTech d-flex-column">
        {props.tool === "true" ? (
          <div className="divPhoto">
            <img
              className="photoTech"
              src={props.pathImage}
              alt="Foto da tecnoligia"
            />
          </div>
        ) : (
          <img
            className="photoTech"
            src={props.pathImage}
            alt="Foto da tecnoligia"
          />
        )}
        <h6 className="title">{props.name}</h6>
        <p className="paragraph descTech">{props.description}</p>
      </div>
    </div>
  );
}

export default CardTechnology;
